import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Table, Pagination, Button, Input, Form, Select, Icon, Spin, Divider } from "antd";
import { getAllUsers, getUser } from '../../../actions/UsersActions';
import { getAffiliatesInfo } from '../../../actions/AffiliateActions';
import { getLanguages } from '../../../actions/settings/LanguagesActions';
import { getCurrencies } from '../../../actions/settings/CurrencyActions';
import AddUser from './AddUser'
import ViewUser from './ViewUser'

const { Option } = Select;
class Users extends React.Component {
    state = {
        isAddModalvisible: false,
        editUserModal: { visible: false },
        pageNumber: 1
    };

    componentDidMount() {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        mainPartnerId && this.props.dispatch(getAllUsers(mainPartnerId, pageNumber));
        mainPartnerId && this.props.dispatch(getAffiliatesInfo(mainPartnerId));
        this.props.dispatch(getLanguages());
        this.props.dispatch(getCurrencies());
    }

    onPageChange = (current) => {
        this.setState({ pageNumber: current });
    }

    // On page change get new data
    componentDidUpdate(prevProps, prevState) {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;
        const { firstName, lastName, affiliateId } = this.state;


        if (prevState.pageNumber !== pageNumber || prevProps.affiliates.mainPartnerId !== mainPartnerId) {
            this.props.dispatch(getAllUsers(mainPartnerId, pageNumber, { firstName, lastName, affiliateId }));
        }
    }

    showAddUserModal = () => {
        this.setState({
            isAddModalvisible: true,
        });
    };

    showEditUserModal = (event, row, index) => {
        this.props.dispatch(getUser(row.id)).then(() => this.setState({ editUserModal: { visible: true, row: row } }));
    };

    handleModalCancel = e => {
        this.setState({
            isAddModalvisible: false,
            editUserModal: { visible: false }
        });
    };

    handleFilterUsers = () => {
        const { form } = this.props;
        const { mainPartnerId } = this.props.affiliates;

        this.onPageChange(1);

        form.validateFields((err, values) => {

            if (!err) {
                const { firstName, lastName, affiliateId } = values;

                this.setState({
                    ...values
                });

                this.props.dispatch(getAllUsers(mainPartnerId, 1, { firstName, lastName, affiliateId }))
            }
            // form.resetFields();
        })
    };

    clearItem = (type) => {
        this.props.form.setFieldsValue({
            [type]: undefined,
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { affUser, affUsers } = this.props.affUser;
        const { affiliatesInfo } = this.props.affiliates;

        const sorter = (a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        };

        const columns = [
            {
                title: this.props.intl.messages.id,
                dataIndex: 'id',
                key: 'id',
                filters: [],
                sorter: sorter,
                sortDirections: ['ascend' , 'descend'],
            },
            {
                title: this.props.intl.messages.firstName,
                dataIndex: 'first_name',
                key: 'first_name',
            },
            {
                title: this.props.intl.messages.lastName,
                dataIndex: 'last_name',
                key: 'last_name',
            },
            {
                title: this.props.intl.messages.email,
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: this.props.intl.messages.language,
                dataIndex: 'language',
                key: 'language',
            },
            {
                title: '',
                dataIndex: 'settings',
                key: 'settings',
                render: (value, row, index) => (
                    <div>
                        <i onClick={(e) => this.showEditUserModal(e, row, index)} className='view-icon ta--f-20 ta--mh-12'></i>
                    </div>
                ),
            },
        ];

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        let tableData = [];
        if (affUsers && affUsers.Users) {
            tableData = Object.keys(affUsers.Users).map(key => {
                return {
                    id: affUsers.Users[key].Id,
                    type: affUsers.Users[key].Type,
                    key: affUsers.Users[key].Id,
                    first_name: affUsers.Users[key].FirstName,
                    last_name: affUsers.Users[key].LastName,
                    email: affUsers.Users[key].Email,
                    language: affUsers.Users[key].Language,
                }
            }).sort(this.sorter);
        }

        const affNames = affiliatesInfo &&  Object.entries(affiliatesInfo).map((data, key) =>
                <Option key={key} value={data[0]}>{data[1]}</Option>
        );

        return (
            <div>
                <div className="ta--flex ta--justify-between ta--align-center rtl--row-reverse">
                    <h2 className='ta--main-header ta--flex ta--align-center'>{this.props.intl.messages.users}</h2>

                    {/* Add User Modal */}
                    <AddUser handleModalCancel={this.handleModalCancel} />
                </div>

                {/* Filter Section */}
                <div className='ta--flex ta--filter'>
                    <Form layout="vertical" className='ta--flex ta--align-center ta-flex-grid ta-w100 '>
                        <Form.Item label={this.props.intl.messages.firstName} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('firstName')(
                                <Input placeholder={this.props.intl.messages.firstName} autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.lastName} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('lastName')(
                                <Input placeholder={this.props.intl.messages.lastName} autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.sub} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('affiliateId')(
                                <Select
                                    placeholder={this.props.intl.messages.sub}
                                    className='ta-w100'
                                    dropdownRender={menu => (
                                        <div>
                                          {menu}
                                          <Divider className="ant-select-tree-dropdown" />
                                          <div
                                            className="ant-select-tree-dropdown-render-div"
                                            onMouseDown={e => e.preventDefault()}
                                            onClick={() => this.clearItem('affiliateId')}
                                          >
                                            <Icon type="delete" /> Clear
                                          </div>
                                        </div>
                                    )}
                                >
                                    {affNames}
                                </Select>
                            )}
                        </Form.Item>

                        <Button onClick={this.handleFilterUsers} className='ta--mb-4 ta--mt-24' key="done" type="primary">{this.props.intl.messages.filter}</Button>
                    </Form>
                </div>

                <Spin indicator={antIcon} spinning={this.props.affUser.inProcess}>
                    <Table
                        dataSource={tableData.sort(sorter)}
                        columns={columns}
                        pagination={false}
                        className="ta-aff-table ta--mt-8"
                        footer={() => <div className='ta--pagination-rows'>{this.props.intl.messages.total_rows}: {affUsers && affUsers.RowCount}</div>}
                    >
                    </Table>
                    <Pagination current={this.state.pageNumber} pageSize={13} total={affUsers && affUsers.RowCount} onChange={this.onPageChange} />
                </Spin>

                {/* Edit User Modal */}
                {this.state.editUserModal.visible === true && <ViewUser
                    editUserModal={this.state.editUserModal}
                    handleModalCancel={this.handleModalCancel}
                    rowId={this.state.editUserModal.row}
                    pageNumber={this.state.pageNumber}
                    affUser={affUser}
                />}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates,
        domains: state.domains,
        user: state.user,
        affUser: state.affUser,
        languages: state.languages,
        currencies: state.currencies,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Users)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Users/Users.js